import React from "react";
import cn from "classnames";

import { RegularText } from "components/Text";
import { LoadingView, ErrorView, EmptyView } from "components/Feedback";

import styles from "./styles.module.scss";

/**
 * Простой вертикальный список строк (левые панели справочников).
 * - одиночный клик = onRowClick (выбор)
 * - двойной клик = onRowOpen (открыть свойства)
 */
export const SimpleList = ({
  items = [],
  rowKey,
  getLabel = (item) => item.name,
  activeId,
  onRowClick,
  onRowOpen,
  loading,
  error,
  onRetry,
  topRow,
}) => {
  if (loading) return <LoadingView />;
  if (error) return <ErrorView message={error} onRetry={onRetry} />;

  const getId = typeof rowKey === "function" ? rowKey : (item) => item[rowKey];

  return (
    <div className={styles.list}>
      {topRow}
      {items.length
        ? items.map((item) => {
            const id = getId(item);
            const isActive = String(activeId ?? "") === String(id);
            return (
              <div
                key={id}
                className={cn(
                  styles.row,
                  "hoverBg",
                  isActive && styles.rowActive
                )}
                onClick={() => {
                  if (!isActive) onRowClick?.(item);
                }}
                onDoubleClick={() => onRowOpen?.(item)}
              >
                <RegularText>{getLabel(item)}</RegularText>
              </div>
            );
          })
        : !topRow && <EmptyView />}
    </div>
  );
};

/** Строка «Все» для списков с виртуальным пунктом */
export const SimpleListRow = ({ label, isActive, onClick }) => (
  <div
    className={cn(styles.row, "hoverBg", isActive && styles.rowActive)}
    onClick={onClick}
  >
    <RegularText>{label}</RegularText>
  </div>
);
